import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { FadeUp } from "@/components/Reveal";
import { motion } from "framer-motion";

export default function Shop() {
  const { t } = useI18n();
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data));
  }, []);

  const shown = filter === "all" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="shop-page" className="pt-32 pb-24 bg-[#F7F7F6]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-3">
            <p className="font-mono-label text-[11px] text-neutral-500">[ CATALOGUE / 2026 ]</p>
          </div>
          <div className="md:col-span-9">
            <FadeUp>
              <h1 className="font-serif-display font-light text-5xl md:text-7xl leading-[0.98]">
                {t("sec_catalog_title")}
              </h1>
              <p className="mt-6 max-w-xl text-neutral-600">{t("sec_catalog_sub")}</p>
            </FadeUp>
          </div>
        </div>

        <div className="flex gap-6 mb-10 border-b border-neutral-300 pb-4">
          {[
            { k: "all", l: "All" },
            { k: "peptide", l: "Peptides" },
            { k: "bac_water", l: "Solvent" },
          ].map((f) => (
            <button
              key={f.k}
              data-testid={`filter-${f.k}`}
              onClick={() => setFilter(f.k)}
              className={`font-mono-label text-[11px] pb-2 border-b-2 ${filter === f.k ? "border-black text-black" : "border-transparent text-neutral-500"}`}
            >
              {f.l}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-neutral-300">
          {shown.map((p, i) => (
            <Link
              key={p.id}
              to={`/product/${p.slug}`}
              data-testid={`product-card-${p.slug}`}
              className="group relative border-r border-b border-neutral-300 p-10 bg-white hover:bg-[#F7F7F6] transition-colors duration-500"
            >
              <div className="flex items-center justify-between mb-6 font-mono-label text-[10px] text-neutral-500">
                <span>0{i + 1}</span>
                <span style={{ color: p.accent }}>· {p.dosage}</span>
              </div>
              <div className="spotlight aspect-[3/4] flex items-center justify-center overflow-hidden">
                <motion.img
                  src={p.image_url}
                  alt={p.name}
                  className="max-h-full max-w-full object-contain"
                  whileHover={{ scale: 1.06 }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                />
              </div>
              <div className="mt-6 flex items-end justify-between">
                <h3 className="font-serif-display text-3xl">{p.name}</h3>
                <p className="font-serif-display text-2xl">€{Number(p.price).toFixed(2)}</p>
              </div>
              <div
                className="absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full transition-[width] duration-700"
                style={{ background: p.accent }}
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
